<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
<!--      <CustomerRentMain />-->
      <transition name="slide-fade" mode="out-in">
        <keep-alive>
          <component :is="componentsId" :houseId="mainObj.house_id" :customerOldId="mainObj.now_customer_id" :customerNewId="mainObj.new_customer_id"/>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import ErpTreeStatus from "../../Common/erp-tree-status";
import CustomerRentMain from "./components/CustomerRentMain";
import CustomerRentEditor from "./components/CustomerRentEditor";
import CustomerRentChange from "./components/CustomerRentChange";
import CustomerRentHistory from "./components/CustomerRentHistory";
import CustomerRentBatch from "./components/CustomerRentBatch";
import SaleCarryOver from "./components/SaleCarryOver";
export default {
  name: "CustomerRentMaster",
  components: {
    CustomerRentMain,
    ErpTreeStatus,
    CustomerRentEditor,
    CustomerRentChange,
    CustomerRentHistory,
    CustomerRentBatch,
    SaleCarryOver
  },
  provide(){
    return{
      mainObj:this.mainObj,
      setComponentsId:this.setComponentsId,
      onEventHandel:this.onEventHandel
    }
  },
  data() {
    return {
      mainObj:{
        house_id:"",
        house_name:"",
        rent_id:"",
        history_house_id:"",
        history_house_name:"",
        excel_type:"",
        now_customer_id:"",
        new_customer_id:"",
        sale_type:""
      },
      componentsId:"CustomerRentMain",

    };
  },
  methods: {
    nodeClick(data) {
      const that=this;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      that.mainObj.house_name = tree_str;
      if (data.tree[data.tree.length - 1].type === "room") {
        that.mainObj.house_id = data.tree[data.tree.length - 1].id;
      }else {
        that.mainObj.house_id = "";
      }
      if(!["CustomerRentBatch","SaleCarryOver"].includes(that.componentsId)){
        setTimeout(function () {
          that.setComponentsId("CustomerRentMain")
        },200)
      }
    },
    onEventHandel(model,type){
      const that=this;
      switch (model) {
        case 'SaleCarryOverMain':
          (type==='hide'&&this.setComponentsId('CustomerRentMain'));
          that.now_customer_id="";
          that.new_customer_id="";
          break;
        default:break;
      }
    },
    setComponentsId(componentsId){
      this.componentsId=componentsId
    }
  },
};
</script>

<style lang="scss" scoped>
@import url(common.scss);
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  .content{
    .header{

    }
    .header-where{

    }
    .body{

    }
  }
}
.flow-process-steps-item{
  padding-top: 10px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerRentMaster.vue